import React from 'react'
import Modal from '@components/Common/Modal'
import { ModalProps } from '@interfaces/Modal'
import TableCavalo from '../Table'
import Button from '@components/Common/Button'

const ModalCavalo: React.FC <ModalProps> = props => {

    return(

        <Modal
            {...props}
            title = "Buscar cavalo"
            width = "100%"
        >
            <TableCavalo {...props} />
            <div className='ml-auto mt-4'>
                <Button
                    label="Fechar"
                    onClick={() => props.setOpen(false)}
                />
            </div>
        </Modal>

    )

}

export default ModalCavalo